<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <project-field-form-group
        :submissionId="submissionId"
        :formLabel="'Project / Grower'"
      />
      <div v-if="samples && samples.length">
        <hr />
        <template v-for="(sample, index) in samples">
          <project-feeds-sample-form-group
            :key="index"
            :submissionId="submissionId"
            :sampleId="sample.test_package_sample_id"
            :managedListId="feedTypeOptionsId"
            :addOns="addOns"
            :animalFedOptions="animal_fed_options"
            @updateSampleList="updateSampleList"
          />
        </template>
      </div>
      <b-row class="my-3" align-h="end">
        <b-col cols="2">
          <b-button @click="updateSampleList('add')" variant="success" block>
            <i class="fa fa-plus" /> Add Sample
          </b-button>
        </b-col>
      </b-row>
      <turn-around-select
        :submissionId="submissionId"
        :turnArounds="turnArounds"
      />
      <div v-if="serviceQuestions && serviceQuestions.length">
        <hr />
        <template v-for="(question, index) in serviceQuestions">
          <service-question :key="index" :serviceQuestion="question" />
        </template>
      </div>
    </b-card>
  </div>
</template>
<script>
import ProjectFeedsSampleFormGroup from "./ProjectFeedsSampleFormGroup";
import ProjectFieldFormGroup from "../../misc/ProjectFieldFormGroup";
import TurnAroundSelect from "../../misc/TurnAroundSelect";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { mapActions, mapGetters } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate/src";

export default {
  name: "ProjectFeedsSubmissionForm",
  components: {
    TurnAroundSelect,
    ProjectFeedsSampleFormGroup,
    ProjectFieldFormGroup,
  },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    serviceQuestions: {
      type: Array,
      default: () => [],
    },
    turnArounds: {
      type: Array,
      default: () => [],
    },
    addOns: {
      type: Array,
      default: () => [],
    },
    managedLists: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    samples() {
      return this.currentSubmission.samples;
    },
    feedTypeOptionsId() {
      return this.managedLists.find((item) => item.sub_type === "feed" && item.list === "type").id
    },
    animal_fed_options() {
      return this.createOptionList(
        this.managedLists.find(
          (item) => item.sub_type === "feed" && item.list === "animal_fed"
        ).attribute_lists,
        "animal_fed"
      );
    },
  },
  validations: {
    currentSubmission: {
      test_package_id: { required },
      turnaround_id: { required },
      samples: { required, minLength: minLength(1) },
    },
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    handleSubmissionUpdate(value, field) {
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value,
        name: field,
      });
    },
    createOptionList(list, field) {
      return {
        options: list.map((item) => {
          return { id: item.id, name: item.value };
        }),
        field,
      };
    },
    updateSampleList(action, id) {
      const lastSample = this.samples[this.samples.length - 1];

      let listUpdate;
      
      switch (action) {
        case "add":
          listUpdate = [
            ...this.samples,
            {
              ...lastSample,
              test_package_sample_id: this.$uuid.v4(),
              identifier: `Sample ${this.samples.length + 1}`,
              add_ons: [...lastSample.add_ons],
              sample_feeds: { ...lastSample.sample_feeds },
            },
          ];
          break;
        case "remove":
          listUpdate = this.samples.filter(
            (sample) => sample.test_package_sample_id !== id
          );
          break;
        default:
      }
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: listUpdate,
        name: "samples",
      });
    },
  },
};
</script>
